<template>
  <div class="userLeft">
    <ul>
      <router-link to="/user"><li class="item1" :class="{'active':curNav==1}">个人信息</li></router-link>
      <router-link to="/orderlist"><li class="item2" :class="{'active':curNav==2}">活动订单</li></router-link>
      <router-link to="/proOrderList"><li class="item3" :class="{'active':curNav==3}">商品订单</li></router-link>
      <router-link to="/score"><li class="item4" :class="{'active':curNav==4}">积分记录</li></router-link>
      <router-link to="/reward"><li class="item5" :class="{'active':curNav==5}">推广奖励</li></router-link>
      <router-link to="/address"><li class="item6" :class="{'active':curNav==6}">收货地址</li></router-link>
    </ul>
  </div>
</template>

<script>
  import eventVue from '../../bus.js'
  export default {
    data(){
      return{
        curNav:''
      }
    },
    mounted(){
      eventVue.$on("leftSwitch",(message)=>{
        this.curNav = message
      })
    }
  }
</script>

<style scoped>
  .userLeft{float: left;width: 291px;padding: 34px 0 0 23px;}
  .userLeft ul{}
  .userLeft ul li{
    width:174px;
    height:40px;
    line-height: 40px;
    background:#ffffff;
    border-radius:20px;
    padding-left: 58px;
    cursor: pointer;
    margin-bottom: 25px;
    color: #333333;
  }
  .userLeft ul li:hover{
    background:rgba(86,128,249,1);
    color: #ffffff;
  }
  .userLeft ul li.item1{
    background-image: url("../../assets/images/u-icon1.png");
    background-position: 23px 9px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item1:hover{
    background-image: url("../../assets/images/u-icon1h.png");
    background-position: 23px 9px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item1.active{
    background-image: url("../../assets/images/u-icon1h.png");
    background-position: 23px 9px;
    background-repeat: no-repeat;
    background-color:rgba(86,128,249,1);
    color: #ffffff;
  }
  .userLeft ul li.item2{
    background-image: url("../../assets/images/u-icon2.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item2:hover{
    background-image: url("../../assets/images/u-icon2h.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item2.active{
    background-image: url("../../assets/images/u-icon2h.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
    background-color:rgba(86,128,249,1);
    color: #ffffff;
  }
  .userLeft ul li.item3{
    background-image: url("../../assets/images/u-icon3.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item3:hover{
    background-image: url("../../assets/images/u-icon3h.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item3.active{
    background-image: url("../../assets/images/u-icon3h.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
    background-color:rgba(86,128,249,1);
    color: #ffffff;
  }
  .userLeft ul li.item4{
    background-image: url("../../assets/images/u-icon4.png");
    background-position: 20px 12px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item4:hover{
    background-image: url("../../assets/images/u-icon4h.png");
    background-position: 20px 12px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item4.active{
    background-image: url("../../assets/images/u-icon4h.png");
    background-position: 20px 12px;
    background-repeat: no-repeat;
    background-color:rgba(86,128,249,1);
    color: #ffffff;
  }
  .userLeft ul li.item5{
    background-image: url("../../assets/images/u-icon5.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item5:hover{
    background-image: url("../../assets/images/u-icon5h.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item5.active{
    background-image: url("../../assets/images/u-icon5h.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
    background-color:rgba(86,128,249,1);
    color: #ffffff;
  }
  .userLeft ul li.item6{
    background-image: url("../../assets/images/u-icon6.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item6:hover{
    background-image: url("../../assets/images/u-icon6h.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
  }
  .userLeft ul li.item6.active{
    background-image: url("../../assets/images/u-icon6h.png");
    background-position: 20px 10px;
    background-repeat: no-repeat;
    background-color: rgba(86,128,249,1);
    color: #ffffff;
  }
</style>





// WEBPACK FOOTER //
// src/components/common/leftside.vue